// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/CostType.yaml
// Generated: 2026-10-20T12:35:12.018Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreateCostType, UpdateCostType, CostType } from '@/types/forestry/CostType';

/**
 * CostType Service
 * CRUD operations for CostType via the ABP API.
 */
export const costTypeService = new EntityService<CostType, CreateCostType, UpdateCostType>(
  '/api/forestry/costtype',
  'CostType',
);
